import { useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
import { Feed } from "src/components";
import { CommentSubject } from "src/constants";
import { useSignalR } from "src/hooks";
import { queryKeys, useGetCommentsFeed } from "src/http";

interface Props {
  subjectType: CommentSubject;
  subjectGuid: string;
}

const CommentsFeed = (props: Props) => {
  const { data, isLoading } = useGetCommentsFeed(props.subjectGuid);
  const queryClient = useQueryClient();
  const signalR = useSignalR();

  useEffect(() => {
    const handleShouldRefetchComments = (threadGuid: string) => {
      queryClient.invalidateQueries(queryKeys.comments.getCommentsFeed(threadGuid));
    };

    signalR.onShouldRefetchComments(handleShouldRefetchComments);
    return () => signalR.offShouldRefetchComments(handleShouldRefetchComments);
  }, [queryClient, signalR]);

  function invalidateComments() {
    queryClient.invalidateQueries(queryKeys.comments.getCommentsFeed(props.subjectGuid));
  }

  return (
    <Feed
      subjectType={props.subjectType}
      subjectGuid={props.subjectGuid}
      isLoading={isLoading}
      items={data ?? []}
      onCommentCreated={invalidateComments}
      onCommentEdited={invalidateComments}
      onCommentDeleted={invalidateComments}
    />
  );
};

export { CommentsFeed };
